module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2toc"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("CONTENTS")])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/fm01"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Accumulated Memories")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch01"
    }
  }, [_c('span', {
    staticClass: "font-1"
  }, [_vm._v("CHAPTER ONE")]), _vm._v(" No Surrender")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/ch02"
    }
  }, [_c('span', {
    staticClass: "font-1"
  }, [_vm._v("CHAPTER TWO")]), _vm._v(" Country First")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-1"
  }, [_vm._v("CHAPTER THREE")]), _vm._v(" About Us")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-1"
  }, [_vm._v("CHAPTER FOUR")]), _vm._v(" In the Company of Heroes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-1"
  }, [_vm._v("CHAPTER FIVE")]), _vm._v(" Arab Spring")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-1"
  }, [_vm._v("CHAPTER SIX")]), _vm._v(" Fighting the Good Fight (with and against Ted Kennedy)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-1"
  }, [_vm._v("CHAPTER SEVEN")]), _vm._v(" Nyet (Know Thine Enemy)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-1"
  }, [_vm._v("CHAPTER EIGHT")]), _vm._v(" Know Thyself (Defending the West)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-1"
  }, [_vm._v("CHAPTER NINE")]), _vm._v(" Part of the Main (American Exceptionalism)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-2b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "font-1"
  }, [_vm._v("CHAPTER TEN")]), _vm._v(" Regular Order")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Hidden Valley")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/author",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("About the Authors")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-3n"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Index")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ee5fb14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 69
// module chunks = 0